import { injectGlobal } from "@emotion/css"
import HelveticaNeue57Condensed from "../assets/Helvetica-Neue-LT-57-Condensed.ttf"

injectGlobal`
  @font-face {
    src: url(${HelveticaNeue57Condensed});
    font-family: "Helvetica Neue LT 57 Condensed";
  }
`
